import * as React from "react";
import OnlyQR from "./qr-view/only-qr";
import QRViewCompact from "./qr-view/qr-view-compact";
import QRViewFullSize from "./qr-view/qr-view-full";

export interface ValueQRCreator {
  valueQR: string;
  accountName?: string;
  accountNumber?: string;
}

interface CustomQRCreatorProps {
  value: ValueQRCreator;
  size?: number;
  scale?: number;
  mode?: "compact" | "fullsize" | "onlyqr";
}

const CustomQRCreator = (props: CustomQRCreatorProps) => {
  const { value, size = 100, mode = "onlyqr", scale = 2 } = props;

  return (
    <>
      {mode === "compact" && <QRViewCompact scale={scale} value={value} />}
      {mode === "fullsize" && <QRViewFullSize scale={scale} value={value} />}
      {mode === "onlyqr" && <OnlyQR size={size} value={value.valueQR} />}
    </>
  );
};

export default CustomQRCreator;
